import { useIngredientList } from 'context/Store';
import { useTranslation } from 'react-i18next';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import AccordionBodyButtons from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Overview/AccordionBodyButtons';
import { ImageWithFallback } from 'components/desktop/_general/ImageWithFallback/ImageWithFallback';
import * as ErpRecipe from 'types/Recipe/Detail/ErpNew/ErpRecipe';
import * as Ingredient from 'types/Recipe/Detail/ErpNew/Ingredient';
import * as ProductList from 'types/Recipe/Detail/ErpNew/ProductList';
import * as IngredientList from 'types/_general/Store/IngredientList';
import Style from 'types/_general/Style';

type IProps = RecipeErpViewComponentProps & { erpRecipe: ErpRecipe.Type };

export const AccordionBody = ({ erpRecipe, ...props }: IProps & { erpRecipe: ErpRecipe.Type }) => {
	const { t } = useTranslation();
	const ingredients = useIngredientList();

	const renderSelectedProductName = (ingredient: Ingredient.Type): string => {
		const selectedProduct = ProductList.getSelected(
			ingredient.products,
			ingredient.manuallySearchedProducts
		);
		if (!selectedProduct) return 'Kein Mapping';
		return selectedProduct.name;
	};

	const renderSelectedProductImg = (ingredient: Ingredient.Type): JSX.Element => {
		const selectedProduct = ProductList.getSelected(
			ingredient.products,
			ingredient.manuallySearchedProducts
		);
		return (
			<ImageWithFallback
				src={selectedProduct?.imageUrl}
				className="image-with-fallback"
				style={{
					...style.image,
					objectFit: 'contain',
				}}
			/>
		);
	};

	return (
		<div>
			<AccordionBodyButtons {...props} erpRecipe={erpRecipe} />
			<hr />
			<table className="table table-sm align-middle">
				<thead>
					<tr>
						<th scope="col">{t('_general:INGREDIENTS')}</th>
						<th scope="col">{t('ingredient:PRODUCTS')}</th>
						<th scope="col" style={{ textAlign: 'right' }}>
							{t('recipe:STEPS')}
						</th>
					</tr>
				</thead>
				<tbody>
					{erpRecipe.ingredients.map((ingredient, i) => {
						return (
							<tr key={i}>
								<td style={{ display: 'flex', alignItems: 'center' }}>
									{renderSelectedProductImg(ingredient)}
									<strong>
										{IngredientList.getNameById(
											ingredients,
											ingredient.ingredientId
										)}
									</strong>
								</td>
								<td>{renderSelectedProductName(ingredient)}</td>
								<td style={{ color: '#bbb', textAlign: 'right' }}>
									{t('recipe:STEP') + ' ' + (ingredient.segmentIndex + 1)}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

const style: Style = {
	image: {
		width: '44px',
		height: '44px',
		marginLeft: '-kpx',
		marginRight: '8px',
		border: '1px solid #ccc',
	},
};
